import styled from 'styled-components';
import { SIDEBAR_PADDING } from '../config.js';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';

var SidebarMenuFooterContainer = styled.div.withConfig({
  displayName: "SidebarMenuFooterContainer",
  componentId: "sc-1mvhbjb-0"
})(["display:flex;flex-direction:column;gap:", ";padding:", ";flex-shrink:0;"], themeGet('spacing.md'), SIDEBAR_PADDING);

export { SidebarMenuFooterContainer };
